/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Vs_Pr_Wins_2Inputs */

const en_fc_vs_pr_wins_2 = /** @type {(inputs: Fc_Vs_Pr_Wins_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI tools such as Generative Extend, Object Mask, text-based editing and Enhance Speech.`)
};

/**
* | output |
* | --- |
* | "AI tools such as Generative Extend, Object Mask, text-based editing and Enhance Speech." |
*
* @param {Fc_Vs_Pr_Wins_2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_vs_pr_wins_2 = /** @type {((inputs?: Fc_Vs_Pr_Wins_2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Vs_Pr_Wins_2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_vs_pr_wins_2(inputs)
});
export { fc_vs_pr_wins_2 as "fc.vs.pr_wins.2" }